/** Same-origin, root-relative: CloudFront routes `/pack-samples/*`, `/generations/*` and
 *  `/previews/*` to the content bucket. Shared by `theme.ts` and `IdentityPanel.tsx`, which
 *  `theme.ts` imports. */
export const tileImageUrl = (imageKey: string) => `/${imageKey}`
export const takeImageUrl = (imageKey: string) => `/generations/${imageKey}`
export const previewImageUrl = (rowId: string, n: number) => `/previews/${rowId}/${n}.webp`
/** A private training photo, through the ownership-checked proxy the intake's restored slots use. */
export const trainingPhotoUrl = (s3Key: string) => `/api/model/photo?key=${encodeURIComponent(s3Key)}`
